import React from "react";
import kavres from "./kavres.json";
import "./kavres.scss";
import Cardrumah from "../../../component/cardrumah/cardrumah.jsx";
import sentosacove from "../../../asset/kavres/sentosacove/sentosacove.js";
import derawan from "../../../asset/kavres/derawan/derawan.js";
const imageMap = {
  sentosacove,
  derawan,
  // Add other image arrays here if you have more sets
};

const Kavres = () => {
  return (
    <div className="kavres">
      <div className="container-kavres">
        <div className="header">
          <div className="judul-kavres">
            <div className="pink"></div>
            <span>Kavling Residentials</span>
          </div>
        </div>
        <div className="cardhome-container">
          {kavres.cards.map((card, index) => {
            // Determine the logo dynamically
            return (
              <Cardrumah
                key={index}
                carousel={imageMap[card.imagesKey]}
                title={card.title}
                subtitle={card.subtitle}
                price={card.price}
                subprice={card.subprice}
                details={card.details}
                whatsappLink={card.whatsappLink} // Pass the WhatsApp link
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Kavres;
